export const ids = [
	'created',
	//
	'email-changed',
	'name-changed',
	//
	'employment-start-changed',
	'employment-end-changed',
	'cohort-changed',
	//
	'idp-user-linked',
	//
	'usergroup-changed',
	'scope-changed',
	'scopes-changed',
	//
	'usergroup-overriden',
	'scope-overriden',
	'scopes-overriden',
	'overrides-cleared',
	//
	'revived',
	//
	'deleted',
] as const;
